import icyMenu from './icyMenu'
import chuanyiMenu from './chuanyiMenu'
import sidebar from './sidebar'

export default {
  menu : /ichuanyi\.com/.test(location.host) ? chuanyiMenu : icyMenu,
  sidebar
}
